<script setup lang="ts">
import { reactive } from "vue";
import LocationSearch from "@/components/Search/LocationSearch.vue"
import CmsDataProvider, { CMS_DATA_ID } from "@/providers/cms.provider";
import { LocationData } from "@/repositories/places.repository";
import { usePlatformStore } from "@/stores/platform.store";
import { addToDataLayer } from "@/services/gtm.service";
import { LngLat } from "mapbox-gl";

const state = reactive<{
    selectedLocation?: LocationData,
    location?: LngLat,
    selectedDistance?: { label: string, value: number },
}>({
});

const cmsData = CmsDataProvider.get<{
    searchUrl?: string,
    placeholder?: string
}>(CMS_DATA_ID.ACTIVITEITEN_SEARCH_HEADER);

const platformStore = usePlatformStore();

const onLocationSelected = (data: LocationData) => {

    addToDataLayer('search', {
        'search_term': data.Naam ?? ''
    });

    if (!state.selectedDistance) {
        state.selectedDistance = { label: '25 KM', value: 25 }
    }

    state.selectedLocation = data;
    state.location = new LngLat(data.Longitude, data.Latitude);

}

const search = () => {
    if (state.location != null && state.selectedDistance) {
        const url = cmsData.searchUrl + '?centerLat=' + state.location.lat + '&centerLon=' + state.location.lng + '&distanceInKms=' + state.selectedDistance.value + '&OrderBy=Distance';
        window.location.href = url;
    }

}
</script>

<template>
    <form class="form sport-in-search-header-form controls" @submit.prevent>
        <LocationSearch :selected-location="state.selectedLocation" @select="onLocationSelected"
            :hide-location-attempt="true" :hide-title="true" :placeholder="cmsData.placeholder">
            <template #actions>
                <span class="icon icon-search d-none d-md-block"></span>
                <button class="btn btn-secondary d-block d-md-none" @click="search()">
                    <span class="icon icon-search" aria-hidden="true" />
                </button>
            </template>
        </LocationSearch>

        <button class="btn btn-secondary btn-with-icon btn-with-icon-left d-none d-md-flex" @click="search()">
            <span class="icon icon-search" aria-hidden="true" />
            <span class="d-none d-md-block">Zoeken</span>
        </button>
    </form>
</template>
